<template>
  <div class="sbe-wrapper">

    <div class="sbe">
      <div id="sbe-back" class="sbe-button-large sbe-button-vorschau " @click="closePreview">{{$t('back')}}</div>

      <div class="sbe-preview">
      <div class="sbe-preview-bubble"></div>
    </div>
    <div class="sbe-input">
      <h2 class="sbe-h2">{{$t('speech_bubble_editor_headline')}}</h2>
      <textarea id="sbe-field" name="sbe-field" rows="4" cols="50" maxlength="" placeholder="" v-model="bubbleText"  @input ="updateBubbleText"></textarea>

      <div class="sbe-options">
        <div class="sbe-center-vert sbe-flex">
          <div>{{$t('speech_bubble_editor_size')}}:</div>
          <div class="sbe-center-vert sbe-bubbles">
            <div class="sbe-center-vert sbe-icon-bubble-wrapper"  @click="setSize('SIZE_BIG')">
              <svg class="sbe-icon-bubble gross" xmlns="http://www.w3.org/2000/svg" width="53" height="42" viewBox="-2 -2 56 44"><path vector-effect="non-scaling-stroke" d="M1025.63,384H991.366a9.1,9.1,0,0,0-9.366,8.8v13.647a9.1,9.1,0,0,0,9.366,8.8h10.254L1000.35,426l10.29-10.741h14.99a9.1,9.1,0,0,0,9.37-8.8V392.806A9.1,9.1,0,0,0,1025.63,384Z" transform="translate(-982 -384)"/></svg>
              {{$t('speech_bubble_editor_big')}}
            </div>
            <div class="sbe-center-vert sbe-icon-bubble-wrapper" @click="setSize('SIZE_MED')">
              <svg class="sbe-icon-bubble mittel" xmlns="http://www.w3.org/2000/svg" width="53" height="42" viewBox="-2 -2 56 44"><path vector-effect="non-scaling-stroke" d="M1025.63,384H991.366a9.1,9.1,0,0,0-9.366,8.8v13.647a9.1,9.1,0,0,0,9.366,8.8h10.254L1000.35,426l10.29-10.741h14.99a9.1,9.1,0,0,0,9.37-8.8V392.806A9.1,9.1,0,0,0,1025.63,384Z" transform="translate(-982 -384)"/></svg>
              {{$t('speech_bubble_editor_middle')}}
            </div>
            <div class="sbe-center-vert sbe-icon-bubble-wrapper" @click="setSize('SIZE_SMALL')">
              <svg class="sbe-icon-bubble klein" xmlns="http://www.w3.org/2000/svg" width="53" height="42" viewBox="-2 -2 56 44"><path vector-effect="non-scaling-stroke" d="M1025.63,384H991.366a9.1,9.1,0,0,0-9.366,8.8v13.647a9.1,9.1,0,0,0,9.366,8.8h10.254L1000.35,426l10.29-10.741h14.99a9.1,9.1,0,0,0,9.37-8.8V392.806A9.1,9.1,0,0,0,1025.63,384Z" transform="translate(-982 -384)"/></svg>
              {{$t('speech_bubble_editor_small')}}
            </div>
          </div>
        </div>
        <div class="sbe-center-vert sbe-flex">
          <div>{{$t('speech_bubble_editor_color')}}:</div>
          <div class="sbe-center-vert">
            <div class="sbe-icon-farbe schwarz" @click="setFillColor('schwarz')"></div>
            <div class="sbe-icon-farbe blau" @click="setFillColor('blau')"></div>
            <div class="sbe-icon-farbe gruen" @click="setFillColor('gruen')"></div>
            <div class="sbe-icon-farbe rot" @click="setFillColor('rot')"></div>
            <div class="sbe-icon-farbe gelb" @click="setFillColor('gelb')"></div>
            <div class="sbe-icon-farbe weiss" @click="setFillColor('weiss')"></div>
          </div>
        </div>
        <div class="sbe-center-vert sbe-flex">
          <div>{{$t('speech_bubble_editor_fontcolor')}}:</div>
          <div class="sbe-center-vert">
            <div class="sbe-icon-farbe schwarz" @click="setFontColor('schwarz')"></div>
            <div class="sbe-icon-farbe blau" @click="setFontColor('blau')"></div>
            <div class="sbe-icon-farbe gruen" @click="setFontColor('gruen')"></div>
            <div class="sbe-icon-farbe rot" @click="setFontColor('rot')"></div>
            <div class="sbe-icon-farbe gelb" @click="setFontColor('gelb')"></div>
            <div class="sbe-icon-farbe weiss" @click="setFontColor('weiss')"></div>
          </div>
        </div>
        <div class="sbe-center-vert sbe-flex">
          <div>{{$t('speech_bubble_editor_bordercolor')}}:</div>
          <div class="sbe-center-vert">
            <div class="sbe-icon-farbe schwarz" @click="setBorderColor('schwarz')"></div>
            <div class="sbe-icon-farbe blau" @click="setBorderColor('blau')"></div>
            <div class="sbe-icon-farbe gruen" @click="setBorderColor('gruen')"></div>
            <div class="sbe-icon-farbe rot" @click="setBorderColor('rot')"></div>
            <div class="sbe-icon-farbe gelb" @click="setBorderColor('gelb')"></div>
            <div class="sbe-icon-farbe weiss" @click="setBorderColor('weiss')"></div>
          </div>
        </div>
      </div>

      <div class="sbe-flex">
        <div class="sbe-button-large sbe-button-vorschau" @click="showPreview">{{$t('speech_bubble_editor_preview')}}</div>
        <div class="sbe-button-large" @click="confirm">{{$t('ok')}}</div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import CustomSpeechBubble from '../CustomSpeechBubble'

export default {
  name: 'BubbleEditor',
  props: ['initialValues'],
  data: () => {
    return {
      previewBubble: null,
      bubbleText: 'Hallo',
      borderColor: '#000000',
      fillColor: '#ffffff',
      fontColor: '#000000',
      size: 'SIZE_MED',
      id: null,
      tail: null
    }
  },

  created () {

  },
  mounted () {

    this.previewBubble = new CustomSpeechBubble(this, $('.sbe-preview-bubble')[0], 0, 0, this, null, true)

    this.bubbleText = this.$t('speech_bubble_editor_text');
    if (this.initialValues != null){
      this.bubbleText = this.initialValues.data.text;
      this.borderColor = this.initialValues.data.borderColor;
      this.fillColor = this.initialValues.data.fillColor;
      this.fontColor = this.initialValues.data.fontColor;
      this.size = this.initialValues.data.size;
      this.id = this.initialValues.instanceHolder.id;
    }

    this.updateBubble()
  },
  destroyed () {
  },
  methods: {
    close () {
      this.$emit('close')
    },
    confirm () {
      this.$emit('confirm', this.getValueObj())
    },
    showPreview () {
      $('.sbe-wrapper')[0].scrollTo(0, 0);
      $('.sbe-preview').show();
      $('#sbe-back').show();
      $('.sbe-wrapper').css('overflow-y', 'hidden');

    },
    closePreview () {
      $('.sbe-preview').hide();
      $('#sbe-back').hide();
      $('.sbe-wrapper').css('overflow-y', 'auto');
    },
    updateBubbleText () {
      this.updateBubble()
      // this.previewBubble.setText (this.bubbleText);
    },
    setFillColor (colorStr) {
      this.fillColor = this.getColorCode(colorStr)
      this.updateBubble()
    },
    setBorderColor (colorStr) {
      this.borderColor = this.getColorCode(colorStr)
      this.updateBubble()
    },
    setFontColor (colorStr) {
      this.fontColor = this.getColorCode(colorStr)
      this.updateBubble()
    },
    setSize (val) {
      this.size = val
      this.updateBubble()
    },

    getColorCode (str) {
      let colorCode = '#000000'
      /*

    --farbe-schwarz: #262626;
    --farbe-blau:    #0095d4;
    --farbe-gruen:   #00d478;
    --farbe-rot:     #cb1417;
    --farbe-gelb:    #ffe600;
    --farbe-weiss:   #efefef;
      */
      switch (str) {
        case 'schwarz':
          colorCode = '#262626'
          break
        case 'blau':
          colorCode = '#0095d4'
          break
        case 'gruen':
          colorCode = '#00d478'
          break
        case 'rot':
          colorCode = '#cb1417'
          break
        case 'gelb':
          colorCode = '#ffe600'
          break
        case 'weiss':
          colorCode = '#efefef'
          break
      }
      return colorCode
    },

    getValueObj () {
      const obj = {
        text: this.bubbleText,
        borderColor: this.borderColor,
        fillColor: this.fillColor,
        fontColor: this.fontColor,
        size: this.size,
        id: this.id
      }
      return obj
    },
    updateBubble () {
      /*
        this.speechBubble.text = obj.text;
  this.speechBubble.panelBorderColor = obj.borderColor
  this.speechBubble.panelFillColor = obj.fillColor
  this.fontColor = obj.fontColor
  this.speechBubble.draw();
       */
      this.previewBubble.clear()
      this.previewBubble.setValues(this.getValueObj())
    }
  }
}
</script>

<style scoped>
.sbe-wrapper{
  width: 100%;
  background: #0095d4;
  height:calc(100vh - 68px - 69px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1500;
  border-top:1px solid white;
  position: absolute;
  overflow-y: scroll;
}

  .sbe *, .sbe *::before, .sbe::after {
    margin: 0; padding: 0;
    box-sizing: inherit;
    font: inherit;
    color: inherit;
  }
  .sbe {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 1080px;
    height: 100%;
    margin: 0 auto;
    padding: 1em;
    box-sizing: border-box;
    font-family: "VAG Rounded Std", "Comic Sans MS", "Comic Sans", sans-serif;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.4;
    letter-spacing: 1px;
    color: #fff;

    --farbe-schwarz: #262626;
    --farbe-blau:    #0095d4;
    --farbe-gruen:   #00d478;
    --farbe-rot:     #cb1417;
    --farbe-gelb:    #ffe600;
    --farbe-weiss:   #efefef;
  }
  /* preview
  -------------------------------------------------- */
  .sbe-preview {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
   transform: scale(1.5);
    pointer-events: none;
  }
  .sbe-preview img {
    max-width: 100%;
  }
  /* user input
  -------------------------------------------------- */
  .sbe-flex {
    display: flex;
    justify-content: space-between;
  }

  .sbe-h2 {
    font-size: 1.5em;
    margin: 0;
    margin-bottom: .2em;
  }
  .sbe-center-vert {
    display: flex;
    align-items: center;
  }

  .sbe-options {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5em;
  }
  .sbe-options > * {
    margin-bottom: 0.8em;
  }

  #sbe-field {
    resize: none;
    background: transparent;
    border: 2px solid #fff;
    width: 100%;
    padding: 0.5em 1em;
    font-family: "Bangers", 'Alegreya Sans', "Comic Sans MS", "Comic Sans", sans-serif;
    font-size: 22px;
    letter-spacing: 2px;
    margin-bottom: 1em;
    height: 3.5em;
  }
  #sbe-field:focus::-webkit-placeholder {
    color:transparent;
  }
  #sbe-field:focus::-moz-placeholder {
    color:transparent;
  }
  #sbe-field:-moz-placeholder {
    color:transparent;
  }
  #sbe-field::placeholder {
    opacity: 0.3;
  }

  .sbe-icon-bubble {
    display: block;
    fill: #fff;
    stroke: #000;
    stroke-width: 1.5px;
    width: auto;
    margin-right: 0.5em;
    cursor: pointer;
    transition: all 0.2s;
  }
  .sbe-icon-bubble:hover {
    filter: drop-shadow(0 0 18px #fff);
    transform: scale(1.2);
  }
  .sbe-icon-bubble.gross {
    height: 2.8em;
  }
  .sbe-icon-bubble.mittel {
    height: 2.2em;
  }
  .sbe-icon-bubble.klein {
    height: 1.8em;
  }
  .sbe-icon-bubble-wrapper {
    margin-left: 1em;
  }

  .sbe-icon-farbe {
    display: block;
    position: relative;
    width: 2em;
    height: 2em;
    margin-right: 0.5em;
    border: .2em solid #fff;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;
  }
  .sbe-icon-farbe:hover {
    filter: drop-shadow(0 0 18px #fff);
    transform: scale(1.2);
  }
  .sbe-icon-farbe.schwarz { background: var(--farbe-schwarz) }
  .sbe-icon-farbe.blau { background: var(--farbe-blau) }
  .sbe-icon-farbe.gruen { background: var(--farbe-gruen) }
  .sbe-icon-farbe.rot { background: var(--farbe-rot) }
  .sbe-icon-farbe.gelb { background: var(--farbe-gelb) }
  .sbe-icon-farbe.weiss { background: var(--farbe-weiss) }

  .sbe-button-large {
    display: inline-block;
    width: 8em;
    padding: 1.2em;
    border-radius: 100px;
    background-color: #0095d4;
    font-size: 1.4em;
    line-height: 0;
    text-align: center;
    border: 2px solid #fff;
    box-shadow: 0 0 28px 2px #fff;
    cursor: pointer;
    transition: all .2s;
  }
  .sbe-button-large:hover {
    background-color: #fff;
    color: #0095d4;
  }
  .sbe-button-vorschau {
    margin-right: 1em;
    display: none;
  }
    #sbe-back{
        display:none;
      position:absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 22;
      width: 190px !important;

    }
  @media screen and (max-width: 768px) {
    .sbe {
      display: block;

    }
    .sbe-preview {
      position:absolute;
      z-index: 20;
      background-color: #0095d4;
      display: none;
      top: 50%;
      left: 50%;
      height: 100vh;
      transform: translate(-50%,-50%) ;
      overflow: hidden;
      width: 100vw;
    }
    .sbe-preview-bubble{
      transform: scale(1.5) translate(-15%, 10%);
    }
    .sbe-h2 {
      font-size: 1.6em;
    }
    .sbe-input {
      width: 100%;
      font-size: 16px;
    }
    .sbe-icon-bubble {
      align-self: flex-start;
      margin-bottom: 0.5em;
    }
    .sbe-button-vorschau {
      display: inline-block;
    }
    .sbe-button-large {
      width: 100%;
    }
  }
  @media screen and (max-width: 440px) {
    .sbe {
      display: block;
    }
    .sbe-bubbles {
      align-items: flex-end;
    }
    .sbe-icon-bubble-wrapper {
      flex-direction: column;
    }
    .sbe-icon-farbe {
      margin-right: 0.4em;
    }
  }
  @media screen and (max-width: 374px) {
    .sbe-preview-bubble{
      transform: scale(1.5) translate(-25%, 10%);
    }
    .sbe-icon-bubble-wrapper {
      margin-left: 0;
      margin-right: 1em;
    }
    .sbe-h2 {
      font-size: 1.4em;
    }
    .sbe-flex {
      display: block;
    }
    #sbe-field {
      height: 4.5em;
    }
    .sbe-button-vorschau {
      margin-right: 0;
    }
    .sbe-flex > * {
      margin-bottom: 0.2em;
    }
  }
</style>
